var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{on:{"page:beforein":_vm.beforein}},[_c('navbar',{attrs:{"text":`${_vm.$t('Configuration.name')} > ${_vm.$t('Page_subtitle_variety')}`}}),_vm._v(" "),(_vm.loaded)?_c('VarietyDatabase',{attrs:{"custom-store":_vm.customStore,"groups-availables":_vm.groupsAvailables,"species-availables":_vm.speciesAvailables}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }